export {};

declare global {
    interface String {
        // tslint:disable-next-line:ban-types
        contains(stringToCompare: String): Boolean;
    }
}

// tslint:disable-next-line:ban-types
String.prototype.contains = function (stringToCompare: String) {
    return this.indexOf(stringToCompare) !== -1;
};
